import React from "react";
import { X } from "lucide-react";

interface TagProps {
  id: string;
  name: string;
  color: string;
  onRemove?: (id: string) => void;
  className?: string;
}

const Tag: React.FC<TagProps> = React.memo(({ id, name, color, onRemove, className = "" }) => {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${className}`}
      style={{
        backgroundColor: `${color}20`,
        color: color,
        border: `1px solid ${color}40`,
      }}
    >
      {name}
      {onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove(id);
          }}
          className="hover:opacity-70 transition-opacity"
          aria-label={`Remove ${name} tag`}
        >
          <X size={12} />
        </button>
      )}
    </span>
  );
});

export default Tag;
